<template>
  <component
    v-if="customIcon"
    :is="customIcon"
    :class="baseClass"
    stroke="currentColor"
  />
</template>

<script lang="ts">
  export default {
    name: 'BIcon',
  }
</script>

<script setup lang="ts">
const icons = {
  placeholder: 'home',
  users: 'user-group',
  book: 'book-open',
  plan: 'currency-dollar',
  home: 'home',
  user: 'user',
  building: 'building-storefront',
  heart: 'heart',
  question: 'question-mark-circle',
  newspaper: 'newspaper',
  bell: 'bell',
  chevronRight: 'chevron-right',
  chevronDoubleRight: 'chevron-double-right',
  chevronLeft: 'chevron-left',
  chevronDoubleLeft: 'chevron-double-left',
  chevronDown: 'chevron-down',
  chevronUp: 'chevron-up',
  import: 'arrow-down-on-square',
  copy: 'document-duplicate',
  document: 'document',
  documentArrowDown: 'document-arrow-down',
  minusCircle: 'minus-circle',
  checkCircle: 'check-circle',
  exclamationCircle: 'exclamation-circle',
  edit: 'pencil',
  check: 'check',
  search: 'magnifying-glass',
  menu: 'bars-3',
  close: 'x-mark',
  arrowLeft: 'arrow-left',
  collapse: 'chevron-up-down',
  calendar: 'calendar',
  voucher: 'tag',
  x: 'x-mark',
  timetable: 'calendar-days',
  lastMinute: 'clock',
  address: 'map-pin',
  appointment: 'clock',
  giftCard: 'gift',
  pass: 'ticket',
  review: 'star',
  gallery: 'image',
} as const

interface Props {
  icon: keyof typeof icons
  baseClass?: string
  solid?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  baseClass: 'leading-none 4 w-5',
  solid: false
})

const customIcon = defineAsyncComponent(async () => {
  try {
    if (props.solid) {
      return await import(`@/assets/images/icons/solid/${icons[props.icon]}.svg`)
    } else {
      return await import(`@/assets/images/icons/outline/${icons[props.icon]}.svg`)
    }
  } catch (error) {
    return await import(`@/assets/images/icons/outline/home.svg`)
  }
})

/* export default {
  name: 'BIcon',
  props: {
    icon: {
      type: [String, Array],
      default: null
    },
    baseClass: {
      type: String,
      default: 'leading-none 4 w-5'
    },
    solid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    svg () {
      const icon = icons[this.icon] || icons.placeholder

      if (this.solid && icon?.solid) {
        return icon?.solid
      }

      return icon?.outline || icon
    }
  }
} */
</script>
